import { makeStyles } from "@mui/styles";

export const styledFormReportAccident = makeStyles(() => ({
  container: {
    background: "white",
    padding: "60px",
    width: "794px",
    height: "1123px",
    margin: "auto",
    fontFamily: "Times New Roman",
  },

  QuocHieu: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    fontSize: "15px",

    "& .qh": {
      fontWeight: 500,
    },

    "& .tieu-ngu": { fontWeight: 600 },
  },

  title: {
    width: "100%",
    textAlign: "center",
    margin: "18px 0 36px",
    fontSize: "22px",
    fontWeight: 600,
  },

  form: {
    width: "100%",
    textAlign: "left",
    fontSize: 15,
    fontWeight: 500,
    padding: "0 12px",

    "& .line": {
      margin: "8px 0",
    },
  },

  sign: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    "& .title": {
      marginBottom: 30,
      fontWeight: 600,
      fontSize: "16px",
    },
    "& .name": {
      textTransform: "capitalize",
      marginTop: "30px",
    },
  },
}));
